import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { api } from '../../app/Api/ApiSlice'
import { toast } from 'react-toastify'
import InfiniteScroll from 'react-infinite-scroll-component'
import Loader from '../../components/Loader'
import AddAdminCard from '../../components/AddAdminCard'


// organization members
const AddAdmins = () => {
    const { organization } = useParams()

    const [members, setMembers] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    // const [errorMsg, setErrorMsg] = useState("")

    useEffect(() => {
        const getMembers = async () => {
            try {
                setIsLoading(true)
                const response = await api.get(`/${organization}/members`)
                if (response) {
                    setIsLoading(false)
                    setMembers(response.data)
                }
            } catch (error) {
                setIsLoading(false)
                setMembers([])
                toast.error(error.response.data.message)
            }
             finally{
                setIsLoading(false)
            }
        }

        getMembers()
    }, [])

    const refresh = () => { }

    return (
        <div>
            <h3 className="page-header-title">{organization}</h3>
            <span className=''>Members</span>
            <div className="user-list">
                <InfiniteScroll
                    dataLength={members?.length}
                    pullDownToRefresh={true}
                    loader={<Loader />}
                    refreshFunction={refresh}
                >
                    {isLoading && <Loader />}
                    {!isLoading && members.length === 0 && <p className="not-found-msg">No members found</p>}
                    {
                        members.length > 0 && members.map((member) => (
                            <AddAdminCard user={member} key={member._id} />
                        ))
                    }
                </InfiniteScroll>
            </div>
        </div>
    )
}

export default AddAdmins